
import React from 'react';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { FormStepProps } from '../types';

const DeviceProfileStep: React.FC<FormStepProps> = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="space-y-2">
          <Label htmlFor="name">Device Name *</Label>
          <Input
            id="name"
            name="name"
            value={formData.name}
            onChange={handleChange}
            placeholder="Enter device name"
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="department">Department *</Label>
          <select
            id="department"
            name="department"
            value={formData.department}
            onChange={handleChange}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
            required
          >
            <option value="">Select Department</option>
            <option value="Energy">Energy</option>
            <option value="Gas">Gas</option>
            <option value="Water">Water</option>
          </select>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="type">Device Type *</Label>
          <select
            id="type"
            name="type"
            value={formData.type}
            onChange={handleChange}
            className="flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-base ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm"
            required
          >
            <option value="">Select Type</option>
            {formData.department === 'Energy' && (
              <>
                <option value="Smart Meter">Smart Meter</option>
                <option value="IoT Gateway">IoT Gateway</option>
                <option value="Voltage Regulator">Voltage Regulator</option>
                <option value="Energy Sensor">Energy Sensor</option>
                <option value="Solar Inverter">Solar Inverter</option>
              </>
            )}
            {formData.department === 'Gas' && (
              <>
                <option value="Gas Meter">Gas Meter</option>
                <option value="Pressure Sensor">Pressure Sensor</option>
                <option value="Flow Regulator">Flow Regulator</option>
                <option value="Gas Quality Sensor">Gas Quality Sensor</option>
                <option value="Leak Detector">Leak Detector</option>
              </>
            )}
            {formData.department === 'Water' && (
              <>
                <option value="Water Meter">Water Meter</option>
                <option value="Pressure Monitor">Pressure Monitor</option>
                <option value="Flow Sensor">Flow Sensor</option>
                <option value="Quality Monitor">Quality Monitor</option>
                <option value="Leak Detector">Leak Detector</option>
              </>
            )}
          </select>
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="category">Category *</Label>
          <Input
            id="category"
            name="category"
            value={formData.category}
            onChange={handleChange}
            placeholder="e.g. Monitoring, Control"
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="serial">Serial Number *</Label>
          <Input
            id="serial"
            name="serial"
            value={formData.serial}
            onChange={handleChange}
            placeholder="Enter unique serial number"
            required
          />
        </div>
        
        <div className="space-y-2">
          <Label htmlFor="location">Location</Label>
          <Input
            id="location"
            name="location"
            value={formData.location}
            onChange={handleChange}
            placeholder="e.g. Building A, Room 101"
          />
        </div>
      </div>
      
      <div className="space-y-2">
        <Label htmlFor="description">Description</Label>
        <Input
          id="description"
          name="description"
          value={formData.description}
          onChange={handleChange}
          placeholder="Additional details about this device"
        />
      </div>
    </div>
  );
};

export default DeviceProfileStep;
